function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.95 15.03v4.47c0 .856.694 1.55 1.55 1.55h15a1.55 1.55 0 001.55-1.55v-15a1.55 1.55 0 00-1.55-1.55h-15A1.55 1.55 0 002.95 4.5v10.47a.824.824 0 000 .06zm1.6-.83V4.55h14.9v9.65h-2.64a1.55 1.55 0 00-1.096.454l-1.796 1.796h-3.837l-1.796-1.796a1.55 1.55 0 00-1.096-.454zm0 1.6h2.618l1.796 1.796a1.55 1.55 0 001.096.454h3.879a1.55 1.55 0 001.096-.454L16.83 15.8h2.619v3.65H4.55z",
    fill: props.fill,
    fillRule: "evenodd"
  }));
}

export default SvgTray;